// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ujplX","title":"styles_title__zhSo2"};